import 'hammerjs';

import { AppModule } from './app/app.module';
import { defineCustomElements } from '@ionic/pwa-elements/loader'; // capacitor support
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    // ngZone: 'noop',
  })
  .catch((err) => console.error(err));

defineCustomElements(window);
